import React, { useState, useEffect } from 'react';

import { Container } from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { useHistory } from 'react-router';
import { Initiate as SDK_INITIATE } from 'Components/Api/SDKAPI';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const SDKGenerateUrl = () => {
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [responseMessage, setResponseMessage] = useState('');

    const history = useHistory();

    useEffect(() => {
        setLoadingOpen(true);
        Initiate();
    }, []);

    const Initiate = async () => {
        if (loadingOpen) {
            setLoadingOpen(false);
            return;
        }
        setIsError(false);
        var response = await SDK_INITIATE();

        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }
        setSeverity('success');
        let data = JSON.parse(response.data);
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(data.Message);

            setIsError(true);
            return;
        }
        setResponseMessage(data.Message);
        let param = {
            RedirectURL: data.RedirectURL
        };

        history.push('/SDKURLRedirect', param);
        return;
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            SDK Transaction
        </CustomContainer>
    );
};
